import React from 'react';
import Report from './report';
import { useIntl } from 'umi';
import GrcReport from '@/pages/intelligence/assets/svg/dataSource/grcReport.svg';

// Game Research Report页面
const GameResearchReport = () => {
  const { formatMessage } = useIntl();

  return (
    <Report
      reportType="gameResearchReport"
      title={
        <div className="dbi-global-view-title">
          <img src={GrcReport} className="view-title-img-front" />
          {formatMessage({ id: 'dbi_game_research_report' })}
        </div>
      }
      subTitle={formatMessage({ id: 'dbi_game_research_report_intro' })}
      // segmentList={segmentList}
    />
  );
};

export default GameResearchReport;
